import { render, staticRenderFns } from "./MaestroIcon.vue?vue&type=template&id=356e63c4&"
import script from "./MaestroIcon.vue?vue&type=script&lang=js&"
export * from "./MaestroIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports